import { createStore } from 'zustand';
import type { DragHandlerState } from './interfaces';

export const dragHandlerStateFactory = () => {
  return createStore<DragHandlerState>((set) => ({
    rowRects: null,
    columnRects: null,
    columnNodePos: null,
    rowNodePos: null,
    tableNodePos: null,
    totalRows: 0,
    totalColumns: 0,
    currentRowIndex: 0,
    currentColumnIndex: 0,
    visible: false,
  }));
};

export type DragHandlerStore = ReturnType<typeof dragHandlerStateFactory>;
